import React from 'react';
import { motion } from 'framer-motion';
import '../style.css';
import '../nov.css';

const LabelsPartners = () => {
  const labels = [
    {
      name: "Media Nov Inc.",
      description: "Our in-house label focusing on FOLK.",
      logo: "/medinov.png"
    },
    {
      name: "Media Nov Music",
      description: "Our in-house label focusing on POP.",
      logo: "/medinov.png"
    },
    {
      name: "Media Nov Records",
      description: "Our in-house label focusing on DANCE.",
      logo: "/medinov.png"
    },
    {
      name: "Media Nov Studios",
      description: "Our in-house label focusing on ELECTRONIC.",
      logo: "/medinov.png"
    }
  ];

  return (
    <section id="labels-partners" className="bg-black py-12 lg:py-20 relative overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-4 lg:px-0 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          
          {/* Left Side - Content */}
          <div className="flex flex-col justify-center lg:col-span-1 order-last lg:order-first">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <div className="mb-6">
                <span className="text-sm font-medium badge-gradient text-gray-700 py-2 px-5 rounded-full inline-block uppercase tracking-wide" style={{ fontFamily: 'aesthet-nova' }}>
                  ✨ Our Trusted Network
                </span>
              </div>
              
              <h2 
                className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white uppercase" 
                style={{ fontFamily: 'aesthet-nova' }}
              >
                <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">
                  OUR
                </span>
                <br />
                <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">
                  LABELS
                </span>
              </h2>
              
              <p 
                className="text-base md:text-lg font-light text-gray-300 leading-relaxed mb-8" 
                style={{ fontFamily: 'aesthet-nova' }}
              >
                Media Nov collaborates with these industry leaders to bring your music to the widest possible audience.
              </p>
            </motion.div>
          </div>

          {/* Right Side - Label Cards Grid */}
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
            {labels.map((label, index) => (
              <motion.div 
                key={index} 
                className={`partner-card group relative flex flex-col justify-between rounded-[24px] px-4 py-3 h-32 text-sm font-medium shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white ${index % 2 !== 0 ? 'md:mt-12' : ''}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: index * 0.15, duration: 0.5 }}
                whileHover={{ 
                  y: -8,
                  scale: 1.05,
                  transition: { duration: 0.3, type: "spring", stiffness: 300 }
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                
                <div className="relative z-10 flex flex-col items-center justify-center h-full">
                  <motion.div
                    className="icon-gradient w-12 h-12 rounded-[16px] flex items-center justify-center mb-1.5"
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    transition={{ duration: 0.3 }}
                  >
                    <img 
                      alt={label.name} 
                      className="w-8 h-auto grayscale group-hover:grayscale-0 transition-all duration-300"
                      src={label.logo}
                    />
                  </motion.div>
                  <motion.h3 
                    className="text-xs font-semibold mb-0.5 uppercase text-center text-black" 
                    style={{ fontFamily: 'aesthet-nova' }}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.15 + 0.2 }}
                  >
                    {label.name}
                  </motion.h3>
                  <motion.p 
                    className="text-gray-600 text-[9px] text-center leading-tight" 
                    style={{ fontFamily: 'aesthet-nova' }}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.15 + 0.3 }}
                  >
                    {label.description}
                  </motion.p>
                </div>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default LabelsPartners;
